import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { ProductDetailOpticsFeatures } from './ProductDetailOpticsFeatures.js';

const ProductDetailOpticsFeaturesContainer = (props)=>{
    const { getLabel  } = useIntl();
    const labels = {
        frame: getLabel('products.frame'),
        antiReflex: getLabel('products.lens.features.antiReflex'),
        antiScratch: getLabel('products.lens.features.antiScratch')
    };
    return /*#__PURE__*/ React.createElement(ProductDetailOpticsFeatures, {
        className: props.className,
        labels: labels
    });
};

export { ProductDetailOpticsFeaturesContainer };
//# sourceMappingURL=ProductDetailOpticsFeaturesContainer.js.map
